<script>

import Login from './components/Login'
import Navigation from './components/Navigation'
import Credentials from './components/Credentials'
import Api from './components/Api'
import TestSetup from './components/TestSetup'
import LunaIntroduction from './components/LunaIntroduction'

export default {
  components: {
    Login,
    Navigation,
    TestSetup,
    LunaIntroduction
  },

  data() {
    return {
      didLogin: false,
      isModalActive: false
    }
  },

  methods: {
    onLogout() {
      Credentials.set(Api.defaultEnvironment, null)
      location.reload()
    }
  },

  computed: {
    hasCredentials() {
      return this.didLogin || !!Credentials.get(Api.defaultEnvironment)
    },

    wrapperClass() {
      if (!this.hasCredentials) {
        return 'hero is-fullheight'
      }
      return 'site'
    },

    environmentUrl() {
      return Api.hosts[this.environment]
    },

    environment() {
      return Api.defaultEnvironment
    }
  }
}
</script>

<template>

  <section :class="wrapperClass">

    <b-modal :active.sync="isModalActive" :width="640" scroll="keep">
      <luna-introduction></luna-introduction>
    </b-modal>

    <navigation v-if="hasCredentials" @logout="onLogout" @clickBrand="isModalActive = true"></navigation>
    <test-setup v-if="hasCredentials" class="main-content"></test-setup>
    <footer class="footer" v-if="hasCredentials">
      <div class="content has-text-centered">
        <p>
          You're currently using <i><a :href="environmentUrl" target="_blank" rel="nofollow">{{ environment }}</a></i>.
        </p>
      </div>
    </footer>
    <login v-else @success="didLogin = true"></login>

  </section>

</template>

<style lang="scss">
nav .column button{
  margin: 20px;
}

.site {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  .main-content {
    flex: 1;
  }
}
footer.footer {
  padding: 2rem 1.5rem 2rem;
}
</style>
